const breakPoint = 767;
let resizeFlag   = false;
let windowWidth  = window.innerWidth;
let windowHeight = window.innerHeight;
let windowWidthJ = $(window).width();




// ------------------------------------------------------------------------
// storySlider
// ----- BOTH
// ------------------------------------------------------------------------
const storySlider = () => {
  $(".gallery-list").each(function(i) {
    $(this).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      speed: 500,
      cssEase: 'ease',
      variableWidth: true,
      appendArrows: '#slideNav_Wrap-'+i,
      appendDots: '#slideNav_Dots-'+i,
      responsive: [
         {
           breakpoint: 768,
           settings: {
             slidesToShow: 1,
             swipeToSlide: true,
             swipe: true,
             edgeFriction: 0.01,
           }
         }
       ]
    });
  });
};



// ------------------------------------------------------------------------
// staffToggle
// ----- BOTH
// ------------------------------------------------------------------------
const staffToggle = () => {
  let tabs = $(".tab-item a");
  $(".tab-item a").on("click", function() { // tabをクリックしたらイベント発火
    $(".current").removeClass("current"); // currentクラスを消す
    $(this).addClass("current"); // クリックした箇所にactiveクラスを追加
    const index = tabs.index(this); // クリックした箇所がタブの何番目か判定し、定数indexとして定義
    $(".tab-content").removeClass("show").eq(index).addClass("show"); // showクラスを消して、contentクラスのindex番目にshowクラスを追加
  })
};



export {
  storySlider,
  staffToggle
}



// WEBPACK FOOTER //
// ./src/assets/js/include/module.js